import React, { Fragment } from 'react';
import T from 'prop-types';

import skeletons from './Skeletons';
import InsightsSDK from './InsightsSDK';
import InsightsXRay from './InsightsXRay';
import InsightsSlider from './InsightsSlider';
import InsightsVersions from './InsightsVersions';
import InsightsAppDetails from './InsightsAppDetails';
import InsightsDescription from './InsightsDescription';
import SectionErrorWithReload from '../SectionErrorWithReload';
import Container from '../../../../../components/Container';
import Button from '../../../../../components/Buttons/Button';
import SwitchStores from '../../../../../components/SwitchStores';

import { ASSETS, SUB_ASSETS } from '../../config/assets';
import { decorateSettings } from '../../utils';

const InsightsDetails = ({
  open,
  settings,
  details,
  store,
  app,
  handleStoreChange,
  onClose,
}) => {
  const { isPending, isError } = decorateSettings(settings);
  const showStoreSwitcher = Object.keys(app.ref_nos_by_store).length > 1;

  return (
    <div className="app-insights-details">
      <Container maxWidth={1128} className="app-insights-details__wrapper">
        {isError ? (
          <SectionErrorWithReload
            assetName={ASSETS.app_details}
            subAssets={SUB_ASSETS[ASSETS.app_details]}
          />
        ) : (
          <Fragment>
            {/* HEADER */}
            {isPending
              ? skeletons.detailsHeader
              : (
                <div className="app-insights-details__header">
                  <div className="app-insights-details__header-left">
                    {showStoreSwitcher && (
                      <SwitchStores
                        active={store}
                        onChange={handleStoreChange}
                      />
                    )}
                  </div>
                  <div className="app-insights-details__header-right">
                    <Button
                      variant="secondary"
                      shape="square"
                      onClick={onClose}
                    >
                      <i className="hicon-close-2" />
                    </Button>
                  </div>
                </div>
              )}
            {/* BODY */}
            <div className="app-insights-details__body">
              {/* BODY LEFT */}
              <div className="app-insights-details__body-left">
                <InsightsAppDetails details={details} settings={settings} />
                <InsightsDescription details={details} settings={settings} />
                <InsightsVersions details={details} settings={settings} />
              </div>

              {/* BODY RIGHT */}
              <div className="app-insights-details__body-right">
                <InsightsSlider details={details} settings={settings} store={store} open={open} />
                <InsightsSDK details={details} settings={settings} />
                <InsightsXRay details={details} settings={settings} />
              </div>
            </div>
          </Fragment>
        )}
      </Container>
    </div>
  );
};

InsightsDetails.propTypes = {
  app: T.shape({
    ref_nos_by_store: T.object,
  }).isRequired,
  settings: T.object,
  details: T.object,
  store: T.string,
  open: T.bool,
  handleStoreChange: T.func,
  onClose: T.func,
};

export default InsightsDetails;
